import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {fetchBoardList} from "../api/boardManage";
import {boardState} from "../types/board.types";

export const fetchBoardListAsync = createAsyncThunk(
    'board/fetchBoardList',
    async () => {
        return await fetchBoardList();
    }
);

const initialState: boardState = {
    boardList: [],
    selectBoardType: false,
    lastFetchedAt: 0
};

export const boardSlice = createSlice({
    name: 'board',
    initialState,
    reducers: {
        setSelectBoardType: (state, action: PayloadAction<boolean>) => {
            state.selectBoardType = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBoardListAsync.pending, (state) => {
                console.log('Fetching board list...');
                state.lastFetchedAt = Date.now();
            })
            .addCase(fetchBoardListAsync.fulfilled, (state, action) => {
                state.boardList = action.payload;
            })
            .addCase(fetchBoardListAsync.rejected, (state, action) => {
                console.error('Failed to fetch board list:', action.error);
            });
    },
});

export const { setSelectBoardType } = boardSlice.actions;

export default boardSlice.reducer;